/**
 * Generated by orval. Do not edit manually.
 */

export type InsiderPokerFormatChoice =
  (typeof InsiderPokerFormatChoice)[keyof typeof InsiderPokerFormatChoice]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsiderPokerFormatChoice = {
  nlhe_cash: 'nlhe_cash',
  nlhe_mtt: 'nlhe_mtt',
  nlhe_sng: 'nlhe_sng',
  plo_cash: 'plo_cash',
  plo_mtt: 'plo_mtt',
  other: 'other',
} as const
